import React, { useCallback } from "react";
import { Card, Heading, Box, Flex, Button } from "theme-ui";
import { LP, GT } from "../../../../strings";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { Icon } from "../../../Icon";
import { LoadingOverlay } from "../../../LoadingOverlay";
import { useMyTransactionState } from "../../../Transaction";
import { DisabledEditableRow, StaticRow } from "../../../Trove/Editor";
import { useFarmView3 } from "../../context/FarmViewContext";
import { RemainingLQTY } from "../RemainingLQTY";
import { ClaimReward } from "./ClaimReward";
import { UnstakeAndClaim } from "../UnstakeAndClaim";
import { Yield } from "../Yield";

const selector = ({
  liquidityMiningStake3,
  liquidityMiningLQTYReward3,
  totalStakedUniTokens3
}: LiquityStoreState) => ({
  liquidityMiningStake3,
  liquidityMiningLQTYReward3,
  totalStakedUniTokens3
});
const transactionId = /farm3-/i;

export const Active: React.FC = () => {
  const { dispatchEvent } = useFarmView3();
  let {
    liquidityMiningStake3,
    liquidityMiningLQTYReward3,
    totalStakedUniTokens3
  } = useLiquitySelector(selector);

  totalStakedUniTokens3 = totalStakedUniTokens3.div(1e10);
  liquidityMiningStake3 = liquidityMiningStake3.div(1e10);

  const handleAdjustPressed = useCallback(() => {
    dispatchEvent("ADJUST_PRESSED2");
  }, [dispatchEvent]);

  const transactionState = useMyTransactionState(transactionId);
  const isTransactionPending =
    transactionState.type === "waitingForApproval" ||
    transactionState.type === "waitingForConfirmation";

  const poolShare = liquidityMiningStake3.mulDiv(100, totalStakedUniTokens3);
  const hasStakeAndRewards = !liquidityMiningStake3.isZero && !liquidityMiningLQTYReward3.isZero;

  return (
    <Card>
      <Heading>
        PLSX-EARN LP Staking
        {!isTransactionPending && (
          <Flex sx={{ justifyContent: "flex-end" }}>
            <RemainingLQTY />
          </Flex>
        )}
      </Heading>
      <Box sx={{ p: [2, 3] }}>
        <Box>
          <DisabledEditableRow
            label="Stake LP"
            inputId="farm-stake"
            amount={liquidityMiningStake3.prettify(4)}
            unit={LP}
          />
          {poolShare.infinite ? (
            <StaticRow label="Pool share" inputId="farm-share" amount="N/A" />
          ) : (
            <StaticRow
              label="Pool share"
              inputId="farm-share"
              amount={poolShare.prettify(4)}
              unit={"%"}
            />
          )}
          <Flex sx={{ alignItems: "center" }}>
            <StaticRow
              label="Reward"
              inputId="farm-reward"
              amount={liquidityMiningLQTYReward3.prettify(4)}
              color={liquidityMiningLQTYReward3.nonZero && "success"}
              unit={GT}
            />
          </Flex>

          <Flex sx={{ justifyContent: "flex-end", flex: 1 }}>
            {/* <Yield /> */}
          </Flex>
        </Box>

        <Flex variant="layout.actions">
          <Button
            variant={!liquidityMiningLQTYReward3.isZero ? "outline" : "primary"}
            onClick={handleAdjustPressed}
          >
            <Icon name="pen" size="sm" />
            &nbsp;Adjust
          </Button>
          {!liquidityMiningLQTYReward3.isZero && <ClaimReward />}
        </Flex>
        <Flex>{hasStakeAndRewards && <UnstakeAndClaim />}</Flex>
      </Box>
      {isTransactionPending && <LoadingOverlay />}
    </Card>
  );
};